import React, { useState } from 'react'
import { useEffect } from 'react'
import { ALERT_TYPES, NOTIFICATION_DISPATCH } from '../../utils/Enum'
import { Theme } from '../WebsiteThemeElements'
import { AlertContainer, AlertMessage, AlertMessageContainer, Closebtn, ExpirationBar, AlertTitle, ToastNotification, ToastHeader, ToastTitle, ToastText, ToastClose } from './AlertElements'

const Alert = ({message, type, dispatch, id, secs, title}) => {
    const theme = Theme({})
    const [exit, setExit] = useState(false)
    const [width, setWidth] = useState(0)
    const [intervalId, setIntervalId] = useState(null)
    const [color, setColor] = useState(
      type === ALERT_TYPES.SUCCESS
      ? theme.successColor
      : type === ALERT_TYPES.INFO
      ? theme.infoColor
      : type === ALERT_TYPES.WARNING
      ? theme.warningColor
      : type === ALERT_TYPES.DANGER
      ? theme.errorColor
      : theme.mainColor)

useEffect(() => {
   setExit(true);
    setTimeout(() => {
      //Remove notification from DOM
      dispatch({
        type: NOTIFICATION_DISPATCH.REMOVE_NOTIFICATION,
        id: id
      })
    }, 5000)

  return () => {}
}, [])


  const handleCloseAlert = () => {
    setExit(true);
    setTimeout(() => {
      //Remove notification from DOM
      dispatch({
        type: NOTIFICATION_DISPATCH.REMOVE_NOTIFICATION,
        id: id
      })
    }, 400)
  }
  

  return (
         <ToastNotification type={color}>
          <ToastHeader>
            <div>
              {title && <ToastTitle type={color}>
                {title}
              </ToastTitle>}
              <ToastText>{message}</ToastText>
            </div>
            <ToastClose onClick={() => handleCloseAlert()}>✕</ToastClose>
          </ToastHeader>
        </ToastNotification>
  )
}

export default Alert